export class JsonPatchDocument {

    constructor(path: string, op: string, value: string){
        this.path = path;
        this.op = op;
        this.value = value;
    }

    path: string;
    op: string;
    value: string;
}
